import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home/Home";
import Members from "../pages/Members/Members";
import About from "../pages/About/AboutUs";
import AlliedProfessions from "../pages/AlliedProfessions/AlliedProfessions";
import ActAndRules from "../pages/Act&Rules/ActAndRules";
import Login from "../pages/Login/Login";
import ForgotPassword from "../pages/ForgotPassword/forgot-paassword";
import EnterForgotOtp from "../pages/ForgotPassword/forgot-otp";
import EnterOtp from "../pages/ForgotPassword/otp";
import ChangePassword from "../pages/ForgotPassword/changepassword";
import RegisterdCreateAccount from "../pages/RegisterCreateAccount/registerd-create-account";
import Dashboard from "../pages/userDashboard/dashboard";
import DownloadRec from "../pages/download-recipts/download-recipt";
import ReEntry from "../pages/reEntry/re-entry-form";
import ReEntryDocument from "../pages/reEntry/re-entry-document";
import RenewalDocument from "../pages/renewal/renew-document";
import Renewal from "../pages/renewal/renew-form";
import GoodStandingForm from "../pages/goodStanding/goodstanding-form";
import GoodStandingDocument from "../pages/goodStanding/goodstanding-document";
import PaymentModal from "../pages/static-pages/payment-model";
import TermsConditions from "../pages/TermsConditions/TermsConditions";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import Guidelines from "../pages/Guidelines/guidelines";
import Curriculum from "../pages/Curriculum/Curriculum";
import Gallery from "../pages/Gallery/Gallery";
import Recruitment from "../pages/Recruitment/Recruitment";
import Regulations from "../pages/Regulations/Regulations";

const Router = () => {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/members" element={<Members />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/professions" element={<AlliedProfessions />} />
        <Route path="/act-and-rules" element={<ActAndRules />} />
        <Route path="/curriculums" element={<Curriculum />} />
        <Route path="/recruitment" element={<Recruitment />} />
        <Route path="/regulations" element={<Regulations />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/gallery" element={<Gallery />} />
        {/* <Route path="/guidelines" element={<Guidelines />} /> */}
        {/* <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} /> */}
        {/* otp */}
        {/* <Route path="/otp/:email/:mobile" element={<EnterOtp />} />
        <Route path="/forgot-otp/:email" element={<EnterForgotOtp />} />
        <Route path="/change-password/:email" element={<ChangePassword />} /> */}
        {/* <Route
          path="/registered-create-account"
          element={<RegisterdCreateAccount />}
        />
        <Route path="/user-dashboard" element={<Dashboard />} />
        <Route path="/download" element={<DownloadRec />} />
        <Route path="/re-entry-form" element={<ReEntry />} />
        <Route path="/re-entry-document" element={<ReEntryDocument />} /> */}
        {/* renew */}
        {/* <Route path="/renew/renew-form" element={<Renewal />} />
        <Route path="/renew/renew-document" element={<RenewalDocument />} />
        <Route path="/good-standing-form" element={<GoodStandingForm />} />
        <Route path="/good-standing-document" element={<GoodStandingDocument />} />

        <Route exact path="/payment-status/:trxno/:amount/:status/:status_des/:trx_date" element={<PaymentModal/>} /> */}
      </Routes>
    </div>
  );
};

export default Router;
